/* eslint-disable @next/next/no-img-element */
import * as React from 'react';

import { useParams } from 'next/navigation';

interface Props {
  className?: string;
}

const EcosystemLastLayer: React.FC<Props> = ({ className }) => {
  const { tenant } = useParams<{ tenant: string }>();
  const prefix = tenant === 'technologies' ? 'pt-' : '';

  return (
    <img
      alt="Kvant Ecosystem - Layer 3"
      src={`/public/${prefix}ecosystem-layer3.png`}
      className={className}
    />
  );
};

export default EcosystemLastLayer;
